import { Component, computed, inject } from '@angular/core';
import { ShellDataService } from '@ribera-web/auth-data-acess';
import { ModalRef } from '@ribera-web/ribera-modal-container-ui';

@Component({
  selector: 'lib-promoters-changue-perfil',
  imports: [],
  templateUrl: './promoters-changue-perfil.html',
  styleUrl: './promoters-changue-perfil.scss',
})
export class PromotersChanguePerfil {

  shellDataService = inject(ShellDataService);
  modalRef = inject(ModalRef<string>);

  perfilActivo = computed(() => {
    return this.shellDataService.isPromotorPerfil();
  });

  selectPerfil(valor:boolean) {
    if(this.perfilActivo() === valor) {
      this.modalRef.close('REJECT');
      return;
    }
    this.shellDataService.togglePromotorPerfil();
    this.modalRef.close('REJECT');
  }
}
